import { useLanguage } from '../i18n/LanguageContext';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const TermsOfService = () => {
  const { language, isRTL } = useLanguage();

  const content = {
    en: {
      title: 'Terms of Service',
      lastUpdated: 'Last Updated: January 2026',
      sections: [
        {
          heading: '1. Acceptance of Terms',
          text: `By accessing and using the services of Glow Space LLC ("Company," "we," "our"), you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.`
        },
        {
          heading: '2. Services',
          text: `Glow Space LLC provides aluminium works, glass installation, drywall, flooring, painting, and cleaning services in the UAE. Our services include but are not limited to:

• Aluminium windows, doors, partitions, and facades
• Glass partitions, shopfronts, and frameless installations
• Drywall and gypsum board installation
• Flooring installation and maintenance
• Interior and exterior painting
• Deep cleaning and maintenance services`
        },
        {
          heading: '3. Quotations and Pricing',
          text: `• All quotations are valid for 30 days unless otherwise specified
• Prices are subject to change based on material costs and market conditions
• Final pricing will be confirmed upon site inspection
• Additional work beyond the original scope may incur extra charges`
        },
        {
          heading: '4. Payment Terms',
          text: `• A deposit may be required before work commences
• Payment schedules will be agreed upon in the project contract
• Full payment is due upon project completion unless otherwise agreed
• Late payments may incur additional charges`
        },
        {
          heading: '5. Warranties',
          text: `• We provide warranties on our workmanship as specified in individual contracts
• Warranty periods vary by service type and will be clearly communicated
• Warranties do not cover damage caused by misuse, accidents, or third parties
• Warranty claims must be reported within 7 days of discovery`
        },
        {
          heading: '6. Client Responsibilities',
          text: `Clients are responsible for:

• Providing accurate project requirements and specifications
• Ensuring site access for our team
• Obtaining necessary permits and approvals
• Clearing the work area as required
• Timely communication and decision-making`
        },
        {
          heading: '7. Limitation of Liability',
          text: `Glow Space LLC shall not be liable for:

• Delays caused by circumstances beyond our control
• Damage to pre-existing conditions not disclosed before work began
• Indirect or consequential damages
• Issues arising from client-supplied materials`
        },
        {
          heading: '8. Intellectual Property',
          text: `All designs, drawings, and specifications created by Glow Space LLC remain our intellectual property until full payment is received and ownership is transferred as agreed.`
        },
        {
          heading: '9. Termination',
          text: `Either party may terminate a project agreement with written notice. In case of termination:

• Payment is due for all work completed
• Materials ordered or purchased will be charged
• Cancellation fees may apply as specified in the contract`
        },
        {
          heading: '10. Governing Law',
          text: `These Terms of Service are governed by the laws of the United Arab Emirates. Any disputes shall be resolved in the courts of Dubai, UAE.`
        },
        {
          heading: '11. Contact Information',
          text: `For questions about these Terms of Service, please contact us:

• Email: info@glow-space.com
• Phone: +971 56 683 2840
• Address: Champion Tower, Dubai Sports City, Dubai, UAE`
        }
      ]
    },
    ar: {
      title: 'شروط الخدمة',
      lastUpdated: 'آخر تحديث: يناير 2026',
      sections: [
        {
          heading: '1. قبول الشروط',
          text: `من خلال الوصول إلى خدمات جلو سبيس ذ.م.م ("الشركة"، "نحن"، "لدينا") واستخدامها، فإنك توافق على الالتزام بشروط الخدمة هذه. إذا كنت لا توافق على هذه الشروط، يرجى عدم استخدام خدماتنا.`
        },
        {
          heading: '2. الخدمات',
          text: `تقدم جلو سبيس ذ.م.م أعمال الألمنيوم وتركيب الزجاج والجبس بورد والأرضيات والدهان وخدمات التنظيف في الإمارات. تشمل خدماتنا على سبيل المثال لا الحصر:

• نوافذ وأبواب وفواصل وواجهات الألمنيوم
• فواصل زجاجية وواجهات محلات وتركيبات بدون إطار
• تركيب الجبس بورد وألواح الجبس
• تركيب وصيانة الأرضيات
• الدهان الداخلي والخارجي
• خدمات التنظيف العميق والصيانة`
        },
        {
          heading: '3. عروض الأسعار والتسعير',
          text: `• جميع عروض الأسعار صالحة لمدة 30 يوماً ما لم يُذكر خلاف ذلك
• الأسعار قابلة للتغيير بناءً على تكاليف المواد وظروف السوق
• سيتم تأكيد التسعير النهائي عند فحص الموقع
• قد تتحمل الأعمال الإضافية خارج النطاق الأصلي رسوماً إضافية`
        },
        {
          heading: '4. شروط الدفع',
          text: `• قد يُطلب إيداع قبل بدء العمل
• سيتم الاتفاق على جداول الدفع في عقد المشروع
• يستحق الدفع الكامل عند اكتمال المشروع ما لم يُتفق على خلاف ذلك
• قد تتحمل المدفوعات المتأخرة رسوماً إضافية`
        },
        {
          heading: '5. الضمانات',
          text: `• نقدم ضمانات على جودة عملنا كما هو محدد في العقود الفردية
• تختلف فترات الضمان حسب نوع الخدمة وسيتم إبلاغها بوضوح
• لا تغطي الضمانات الأضرار الناجمة عن سوء الاستخدام أو الحوادث أو الأطراف الثالثة
• يجب الإبلاغ عن مطالبات الضمان خلال 7 أيام من الاكتشاف`
        },
        {
          heading: '6. مسؤوليات العميل',
          text: `العملاء مسؤولون عن:

• تقديم متطلبات ومواصفات المشروع الدقيقة
• ضمان وصول فريقنا إلى الموقع
• الحصول على التصاريح والموافقات اللازمة
• إخلاء منطقة العمل حسب الحاجة
• التواصل واتخاذ القرارات في الوقت المناسب`
        },
        {
          heading: '7. حدود المسؤولية',
          text: `لن تكون جلو سبيس ذ.م.م مسؤولة عن:

• التأخيرات الناجمة عن ظروف خارجة عن إرادتنا
• الأضرار التي لحقت بالحالات الموجودة مسبقاً والتي لم يُفصح عنها قبل بدء العمل
• الأضرار غير المباشرة أو التبعية
• المشكلات الناشئة عن المواد المقدمة من العميل`
        },
        {
          heading: '8. الملكية الفكرية',
          text: `تظل جميع التصميمات والرسومات والمواصفات التي أنشأتها جلو سبيس ذ.م.م ملكيتنا الفكرية حتى استلام الدفع الكامل ونقل الملكية كما هو متفق عليه.`
        },
        {
          heading: '9. الإنهاء',
          text: `يجوز لأي طرف إنهاء اتفاقية المشروع بإشعار كتابي. في حالة الإنهاء:

• يستحق الدفع عن جميع الأعمال المنجزة
• سيتم تحصيل رسوم المواد المطلوبة أو المشتراة
• قد تُطبق رسوم الإلغاء كما هو محدد في العقد`
        },
        {
          heading: '10. القانون الحاكم',
          text: `تخضع شروط الخدمة هذه لقوانين دولة الإمارات العربية المتحدة. يجب حل أي نزاعات في محاكم دبي، الإمارات.`
        },
        {
          heading: '11. معلومات الاتصال',
          text: `للأسئلة حول شروط الخدمة هذه، يرجى الاتصال بنا:

• البريد الإلكتروني: info@glow-space.com
• الهاتف: +971 56 683 2840
• العنوان: برج تشامبيون، مدينة دبي الرياضية، دبي، الإمارات`
        }
      ]
    }
  };

  const t = content[language];
  const fontFamily = isRTL ? "'Noto Sans Arabic', sans-serif" : "'Manrope', sans-serif";
  const headingFont = isRTL ? "'Noto Sans Arabic', sans-serif" : "'Outfit', sans-serif";

  return (
    <div className="min-h-screen bg-[#060B14]" data-testid="terms-of-service-page">
      <Navbar />
      
      <main className="pt-32 pb-20 px-6">
        <div className="max-w-4xl mx-auto">
          <h1 
            className={`text-4xl md:text-5xl font-bold text-white mb-4 ${isRTL ? 'text-right' : ''}`}
            style={{ fontFamily: headingFont }}
          >
            {t.title}
          </h1>
          <p className={`text-slate-400 mb-12 ${isRTL ? 'text-right' : ''}`} style={{ fontFamily }}>
            {t.lastUpdated}
          </p>

          <div className="space-y-8">
            {t.sections.map((section, index) => (
              <div key={index} className={isRTL ? 'text-right' : ''}>
                <h2 
                  className="text-xl font-semibold text-white mb-4"
                  style={{ fontFamily: headingFont }}
                >
                  {section.heading}
                </h2>
                <div 
                  className="text-slate-300 leading-relaxed whitespace-pre-line"
                  style={{ fontFamily }}
                >
                  {section.text}
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default TermsOfService;
